import { render } from "./UsageTrendChart.vue?vue&type=template&id=974f19ba&scoped=true"
import script from "./UsageTrendChart.vue?vue&type=script&lang=js"
export * from "./UsageTrendChart.vue?vue&type=script&lang=js"

import "./UsageTrendChart.vue?vue&type=style&index=0&id=974f19ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-974f19ba"]])

export default __exports__